import React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import closeLogoBlack from "../assets/images/chats/closeLogoBlack.svg";
import { CloseButton, CloseIcon } from "../page/Profille/CustomDrawer";
import profile_background_logo from "../assets/images/Network.svg";
import profile_logo from "../assets/images/auth/profileimg.svg";
import linkedin from "../assets/images/postcard/Linkedin.svg";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.30)",
  borderRadius: "8px",
};

const PictureBox = ({ profileImgUrl, coverImgUrl, initialName = "" }) => (
  
  <Box maxHeight={"8rem"} height="8rem" width={"100%"} position={"relative"}>
    <Box height={"100%"} overflow={"hidden"}>
      <img
        src={coverImgUrl ? coverImgUrl : profile_background_logo}
        alt="coverImg"
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    </Box>

    <Box
      bgcolor={"#EAEAEA"}
      position={"absolute"}
      left="50%"
      marginLeft={"-50px"}
      transform="translateX(-40%)"
      bottom="-20%"
      borderRadius={"0.2rem"}
      overflow={"hidden"}
    >
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        position={"relative"}
        height={"100px"}
        width={"100px"}
        minHeight={"100%"}
        minWidth={"100%"}
      >
        {profileImgUrl ? (
          <img
            src={profileImgUrl ? profileImgUrl : profile_logo}
            alt="profileImg"
            style={{ width: "100%", height: "100%", objectFit: "fill" }}
          />
        ) : (
          <Typography fontSize={"1.8rem"}>
            {initialName && initialName[0]}
          </Typography>
        )}
      </Box>
    </Box>
  </Box>
);

const ProfileOwnerDetailModal = ({
  ownerData,
  groupData,
  viewType,
  open,
  onClose,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const profileViewData = viewType === "owner" ? ownerData : groupData;

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style} overflow="hidden">
        {/* Header */}
        <Box
          display="flex"
          alignItems="center"
          gap="0.4rem"
          bgcolor="rgba(234, 234, 234, 1)"
          padding="0.5rem"
        >
          <CloseButton onClick={onClose} size="small" variant="contained">
            <CloseIcon src={closeLogoBlack} alt="close" />
          </CloseButton>

          <Typography
            color="#000"
            fontSize="1rem"
            variant="h6"
            fontWeight={600}
          >
            {viewType === "owner"
              ? appContent?.KEY14 || "Owner Details"
              : "Group Details"}
          </Typography>
        </Box>

        {/* Profile Header Section */}
        <Box position="relative">
          <PictureBox
            profileImgUrl={profileViewData?.profileImgUrl}
            coverImgUrl={profileViewData?.coverImgUrl}
            initialName={
              viewType === "owner"
                ? profileViewData?.companyName
                : profileViewData?.userName
            }
          />
          {profileViewData?.linkedin && (
            <Box
              sx={{ cursor: "pointer" }}
              position="absolute"
              right="8rem"
              bottom="-1.6rem"
            >
              <Link
                href={
                  profileViewData?.linkedin?.startsWith("http")
                    ? profileViewData?.linkedin
                    : `https://${profileViewData?.linkedin}`
                }
                target="_blank"
                rel="noopener"
              >
                <img src={linkedin} title="Linkedin" alt="linkedin" />
              </Link>
            </Box>
          )}
        </Box>

        {/* Details Section */}
        <Box mt="2rem" textAlign="center" padding="0.5rem 0rem" mb="1rem">
          <Typography fontWeight={600}>
            {profileViewData?.companyName || profileViewData?.userName || "-"}
          </Typography>

          <Typography>
            {profileViewData?.industryName || profileViewData?.email || "-"}
          </Typography>

          {/* Website Link */}
          {profileViewData?.website && (
            <Link
              href={
                profileViewData?.website?.startsWith("http")
                  ? profileViewData?.website
                  : `https://${profileViewData?.website}`
              }
              target="_blank"
              rel="noopener"
            >
              <Typography
                fontSize="0.88rem"
                sx={{ textDecoration: "underline", cursor: "pointer" }}
              >
                {profileViewData?.website}
              </Typography>
            </Link>
          )}

          {/* Location / Industry */}
          <Typography>
            {profileViewData?.industryName &&
              `${profileViewData?.industryName}`}
            {(profileViewData?.cityName || profileViewData?.countryName) && (
              <>
                {profileViewData?.cityName}, {profileViewData?.countryName}
              </>
            )}
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default ProfileOwnerDetailModal;
